import React from "react";
import DefaultAvatar from "utils/DefaultAvatar";
import CustomAvatar from "utils/CustomAvatar";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";

class SubscribeUsersModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			show: false,
			users: this.props.users,
			newSubs: [],
		};
	}

	componentDidMount() {
		// Filter out users who are already subscribed
		let unsubscribedUsers = {};
		Object.keys(this.state.users).forEach((userEmail) => {
			if (!this.props.subscribedUsers.includes(userEmail)) {
				unsubscribedUsers[userEmail] = this.props.users[userEmail];
			}
		});
		this.setState({ users: unsubscribedUsers });
	}
	toggleUser(e) {
		let userEmail = e.target.getAttribute("data-email");
		let newSubs = this.state.newSubs;
		if (this.state.newSubs.includes(userEmail)) {
			newSubs.splice(newSubs.indexOf(userEmail), 1);
		} else {
			newSubs.push(userEmail);
		}
		this.setState({ newSubs: newSubs });
	}

	subscribeUsers(e) {
		this.state.newSubs.forEach((userEmail) => {
			if (userEmail && userEmail != "") {
				let data = this.props.addUser(
					userEmail,
					this.props.sectionName,
					this.props.sectionId
				);
				this.props.addUserCallback(userEmail);
			}
		});
		this.setState({ show: false });
		let sectionTitle = this.props.sectionName.split("Section")[0];
		sectionTitle = sectionTitle == "Seo" ? "SEO" : sectionTitle;
		{
			this.state.newSubs.length > 1
				? DP_FLASH([
						{
							type: "success",
							message: `${this.state.newSubs.length} users were subscribed to ${this.props.clientName} - ${sectionTitle}`,
						},
				  ])
				: DP_FLASH([
						{
							type: "success",
							message: `${this.state.newSubs.length} user was subscribed to ${this.props.clientName} - ${sectionTitle}`,
						},
				  ]);
		}
	}

	searchUsers(e) {
		let filter = e.target.value.toLowerCase();
		let visibleUsers = {};
		Object.keys(this.props.users).forEach((userEmail) => {
			let user = this.props.users[userEmail];
			// If the user is not subscribed already && their name or email matches input
			if (
				!this.props.subscribedUsers.includes(userEmail) &&
				(user.name.toLowerCase().includes(filter) ||
					userEmail.toLowerCase().includes(filter))
			) {
				visibleUsers[userEmail] = user;
			}
		});
		this.setState({ users: visibleUsers });
	}

	render() {

		let sectionTitle = this.props.sectionName.split("Section")[0];
		sectionTitle = sectionTitle == "Seo" ? "SEO" : sectionTitle;

		let newSubs = this.state.newSubs.map((userEmail) => {
			let user = this.props.users[userEmail];
			return (
				<span
					key={user.id}
					data-email={userEmail}
					onClick={(e) => this.toggleUser(e)}
				>
					{user.name}
					<i style={{ pointerEvents: "none" }} className="fa fa-times"></i>
				</span>
			);
		});

		return (
			<>
				<Button
					variant="success"
					className="subscribe-button d-inline-block mb-3"
					style={{ verticalAlign: "baseline" }}
					onClick={(e) => this.setState({ show: true })}
				>
					<span>+</span>
				</Button>
				<Modal
					className="subscribe-users-modal"
					show={this.state.show}
					onHide={(e) => this.setState({ show: false })}
				>
					<div className="page-1">
						<Modal.Header closeButton>
							<Modal.Title>{`${this.props.clientName} - Add ${sectionTitle} Subscribers`}</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<Row>
								<Col>
									<div className="user-search">
										<span className="fa fa-search"></span>
										<input
											onChange={(e) => this.searchUsers(e)}
											placeholder="Enter a name or email address..."
										/>
									</div>
								</Col>
							</Row>
							<Row>
								<Col>
									<ul className="user-list">
										{Object.keys(this.state.users).map((userEmail) => {
											let user = this.state.users[userEmail];
											let avatar = (
												<DefaultAvatar
													dim="32x32"
													name={user.name}
													className="avatar"
													department={user.department}
												/>
											);
											if (user.avatar) {
												avatar = (
													<CustomAvatar
														src={user.avatar}
														className="avatar"
														department={user.department}
													/>
												);
											}
											let selected = this.state.newSubs.includes(userEmail)
												? "selected"
												: undefined;
											return (
												<React.Fragment key={user.id}>
													<li
														onClick={(e) => this.toggleUser(e)}
														data-email={userEmail}
														className={selected}
													>
														<div style={{ pointerEvents: "none" }}>
															<div className="d-inline-block m-0">
																<div className="position-relative d-inline-block">
																	{avatar}
																	<div className="overlay">
																		<i className="fa fa-check"></i>
																	</div>
																</div>
																<b>&nbsp;{user.name}</b>
																<span className="user-email">&nbsp;{userEmail}</span>
															</div>
														</div>
													</li>
												</React.Fragment>
											);
										})}
									</ul>
								</Col>
							</Row>
						</Modal.Body>
						<Modal.Footer>
							<div className="new-subscribers">
								<p>
									<b>To be subscribed:</b>
								</p>
								{newSubs}
							</div>
							<div className="action-buttons">
								<Button
									style={{ backgroundColor: "#A3A3A3" }}
									onClick={(e) => this.setState({ show: false })}
								>
									Cancel
								</Button>
								<Button
									variant="success"
									onClick={(e) => this.subscribeUsers(e)}
								>
									Subscribe users
								</Button>
							</div>
						</Modal.Footer>
					</div>
				</Modal>
			</>
		);
	}
}

export default SubscribeUsersModal;
